var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00002 1.16675C3.77836 1.16675 1.16669 3.77842 1.16669 7.00008C1.16669 10.2217 3.77836 12.8334 7.00002 12.8334C10.2217 12.8334 12.8334 10.2217 12.8334 7.00008C12.8299 3.77986 10.2202 1.17023 7.00002 1.16675ZM9.52778 9.53807C9.34454 9.73199 9.04042 9.74534 8.8409 9.56821L6.43028 7.35835C6.32918 7.26661 6.27132 7.1366 6.27083 7.00009V4.32647C6.27083 4.058 6.48847 3.84036 6.75695 3.84036C7.02542 3.84036 7.24306 4.058 7.24306 4.32647V6.7862L9.4957 8.8512C9.59121 8.93803 9.64826 9.05928 9.65428 9.18822C9.6603 9.31717 9.61479 9.44321 9.52778 9.53856V9.53807Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockSmall);
export default __webpack_public_path__ + "static/media/clock-small.972a41f8.svg";
export { ForwardRef as ReactComponent };